import AuthorsService from '@/services/codebooks/AuthorsService'

export default {
  namespaced: true,
  state: {
    authorsList: []
  },
  getters: {
    authorsList: state => state.authorsList
  },
  actions: {
    refreshAuthors ({ commit }) {
      return AuthorsService.getAllAuthors()
        .then(list => {
          commit('SET_AUTHORS', list)
        })
    },
    addNewAuthor ({ commit }, author) {
      return AuthorsService.saveAuthor(author).then(result => {
        author.id = result.data
        commit('ADD_AUTHOR', author)
        return author
      })
    },
    editAuthor ({ commit }, author) {
      return AuthorsService.saveAuthor(author).then(result => {
        commit('EDIT_AUTHOR', author)
        return author
      })
    },
    deleteAuthor ({ commit }, author) {
      return AuthorsService.removeAuthor(author).then(result => {
        commit('DELETE_AUTHOR', author)
      })
    }
  },
  mutations: {
    SET_AUTHORS (state, list) {
      state.authorsList = list
    },
    EDIT_AUTHOR (state, author) {
      const current = state.authorsList[author.index]
      current.name = author.name
    },
    ADD_AUTHOR (state, author) {
      const newAuthor = {
        id: author.id,
        name: author.name
      }
      state.authorsList.push(newAuthor)
    },
    DELETE_AUTHOR (state, author) {
      state.authorsList.splice(author.index, 1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/codebook/authors.js